module.exports = __webpack_public_path__ + "static/media/safari.581d7378.svg";